<template lang="pug">
  .liaoning-flow
    .header
      img(src="../../assets/images/chongqing/header.png")
    .form
      el-form
        el-form-item
          el-input(type="text", v-model="form.mobile", placeholder="请输入重庆移动手机号")
        el-form-item
          el-col(:span="15")
            el-input(type="text", v-model="form.verifyCode", placeholder="请输入验证码", maxlength="4")
          el-col(:span="9")
            el-button(type="primary", :disabled="leftSendTime > 0", @click="sendVerifyCode")
              span(v-if="leftSendTime <= 0") 获取验证码
              span(v-else) {{leftSendTime}}秒后重试
        el-form-item.button-item
          el-button(type="warning", @click="handleSubmit", :loading="loading") 立即办理
    .notice
      .title - 活动规则 -
      .content
        ul
          li(v-for="(notice, index) in notices", :key="index", v-if="index <= 0 || showMoreNotice")
            .num {{index + 1}}.
            p.content {{notice}}
        .show-more(v-if="!showMoreNotice", @click="showMoreNotice = true") 点击查看更多活动规则
</template>

<script>
export default {
  data() {
    return {
      leftSendTime: 0,
      notices: [
        '资费30元/月,包含10GB的全国（不含港澳台地区）通用上网流量和10GB国内（不含港澳台地区）视频定向流量，所包含流量当月有效。',
        '10GB国内（不含港澳台）视频定向流量包含：咪咕视频、咪咕直播、爱奇艺、优酷视频、PPTV、西瓜视频、芒果视频、抖音视频APP。所有定向流量均不可用于APP中的三方视频、文字、图片、链接、广告、弹幕等内容。',
        '所含流量均当月有效，不可转赠、共享和结转。'
      ],
      form: {
        mobile: '',
        verifyCode: '',
        carrierId: 15,
        userId: '',
        goodsCode: 'TUIA07060001',
        exchangeId: ''
      },
      loading: false,
      channel: 'TUIA',
      showMoreNotice: false
    }
  },
  methods: {
    sendVerifyCode() {
      this.form.mobile = this.form.mobile.trim()
      if(!this.$REGEX.mobile.test(this.form.mobile)) {
        this.$message({
          type: 'warning',
          message: '请填写正确的手机号码'
        })
        return;
      }
      this.$service.CarrierService
        .sendVerifyCode({
          carrierId: this.form.carrierId,
          mobile: this.form.mobile,
          channel: this.channel,
          goodsCode: this.form.goodsCode
        })
        .then(res => {
          if (res.data.success) {
            this.form.exchangeId = res.data.sub_data.exchangeId
            this.leftSendTime = 60
            this.setSendTimeLeft()
            this.$message({
              type: 'success',
              message: '验证码已发送'
            })
          } else {
            this.$message({
              type: 'warning',
              message: res.data.message
            })
          }
        })
        .catch(() => {
          this.$message({
            type: 'error',
            message: '系统错误，或请输入正确的手机号码'
          })
        })
    },
    setSendTimeLeft() {
      if (this.leftSendTime > 0) {
        this.leftSendTime -= 1
        setTimeout(() => {
          this.setSendTimeLeft()
        }, 1000)
      }
    },
    handleSubmit() {
      this.$router.push({
              name: 'CQFlowCommonSuccess'
            })
            return;
      // this.form.mobile = this.form.mobile.trim()
      // this.form.verifyCode = this.form.verifyCode.trim()
      // if(!this.$REGEX.mobile.test(this.form.mobile)) {
      //   this.$message({
      //     type: 'warning',
      //     message: '请填写正确的手机号码'
      //   })
      //   return;
      // }
      // if(this.form.verifyCode.length === 0) {
      //   this.$message({
      //     type: 'warning',
      //     message: '请填写短信验证码'
      //   })
      //   return;
      // }
      // if(this.form.verifyCode.length != 4) {
      //   this.$message({
      //     type: 'warning',
      //     message: '请填写4位验证码'
      //   })
      //   return;
      // }
      // let _loading = this.$loading({
      //   lock: true,
      //   text: '正在处理中',
      //   spinner: 'el-icon-loading',
      //   background: 'rgba(0, 0, 0, 0.7)'
      // })
      // this.loading = true
      // this.$service.CarrierService
      //   .checkMobilePackage({
      //     carrierId: this.form.carrierId,
      //     mobile: this.form.mobile,
      //     goodsCode: this.form.goodsCode,
      //     verifyCode: this.form.verifyCode,
      //     channel: this.channel,
      //     exchangeId: this.form.exchangeId,
      //     userId: this.form.userId || 25995   // 缺省冀的用户ID
      //   })
      //   .then(res => {
      //     if (res.data.success) {
      //       this.addMobilePackage()
      //     } else {
      //       this.$message({
      //         type: 'warning',
      //         message: res.data.message
      //       })
      //     }
      //   })
      //   .catch(() => {
      //     this.$message({
      //       type: 'error',
      //       message: '请求过程中发生错误，请稍后再再试'
      //     })
      //   })
      //   .finally(() => {
      //     _loading.close()
      //     this.loading = false
      //   })
    },
    addMobilePackage() {
      let _formData = {
        carrierId: this.form.carrierId,
        mobile: this.form.mobile,
        userId: this.form.userId || 25995,   // 缺省冀的用户ID,
        goodsCode: this.form.goodsCode,
        verifyCode: this.form.verifyCode,
        exchangeId: this.form.exchangeId,
        channel: this.channel
      }
      if (this.form.sharerId) {
        _formData.sharerId = this.form.sharerId
      }
      let _loading = this.$loading({
        lock: true,
        text: '正在办理业务',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      this.loading = true
      this.$service.CarrierService
        .addMobilePackage(_formData)
        .then(res => {
          if (res.data.success) {
            try{
              // eslint-disable-next-line
              if (window.countLog) {
                // eslint-disable-next-line
                countLog.ready(function() {
                  // eslint-disable-next-line
                  countLog.init(function() { 
                    // 如果需要跳转，在此处写入 window.location.href = 跳转链接 
                  }, {
                    // 是否需要复制订单号，是为 1，不是为 0 
                    isCopy: 0, 
                    // 上报转化类型，具体见下表 
                    pageType: 0 
                  })
                })
              }
            } catch (err) {
              console.log(err)
              this.errlog = err.message;
            }
            this.$message({
              type: 'success',
              message: '办理成功'
            })
            this.$router.push({
              name: 'CQFlowCommonSuccess'
            })
          } else {
            this.$message({
              type: 'warning',
              message: res.data.message
            })
          }
        })
        .catch(() => {
          this.$message({
            type: 'error',
            message: '办理失败，请稍后再再试'
          })
        })
        .finally(() => {
          _loading.close()
          this.loading = false
        })
    }
  }
}
</script>

<style lang="less" scoped>
.liaoning-flow{
  background-color: #41c1ac;
  padding-bottom: 3.5rem;
}
.header{
  img{
    width: 100%;
  }
}
.notice{
  margin-top: 2 rem;
  font: "黑体", "Arial";
  .title{
    text-align: center;
    color: #fff;
    margin-bottom: .5rem;
  }
  >.content{
    background: url('../../assets/images/liaoning/notice-bg.png') no-repeat;
    background-size: 100% 100%;
    padding: 2.5rem 2rem 1.2rem;
    border-radius: .4rem;
    margin: 0 auto;
    width: 82%;
    ul{
      li{
        clear: both;
        overflow: hidden;
        font-size: .8rem;
        color: #4A9F94;
        margin-bottom: .2rem;
        .num{
          float: left;
          width: 1.4rem;
          line-height: 1.2rem;
        }
        .content{
          line-height: 1.2rem;
          margin-left: 1.3rem;

        }
      }
    }
    .show-more{
      text-align: center;
      font-size: .8rem;
      color: #a3a3a3;
    }
  }
}
.form{
  width: 80%;
  margin: 0 auto;
  .button-item{
    text-align: center;
    .el-button{
      width: 100%;
    }
  }
}
</style>
